import React, { useEffect, useState } from "react";
import { Dropdown, Option } from "@fluentui/react-components";
import i18n from "@shared/i18n";

const languageOptions = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
];

const LanguageSwitcher = () => {
  const [selectedLang, setSelectedLang] = useState(() => {
    return localStorage.getItem("locale") || i18n.language || "en";
  });

  useEffect(() => {
    if (i18n.language !== selectedLang) {
      i18n.changeLanguage(selectedLang);
    }
  }, [selectedLang]);

  const handleChange = (event, data) => {
    const newLang = data.optionValue;
    localStorage.setItem("locale", newLang);
    setSelectedLang(newLang);
  };

  const selectedLabel = languageOptions.find((opt) => opt.value === i18n.language)?.label || "English";

  return (
    <Dropdown value={selectedLabel} onOptionSelect={handleChange}>
      {languageOptions.map((opt) => (
        <Option key={opt.value} value={opt.value}>
          {opt.label}
        </Option>
      ))}
    </Dropdown>
  );
};

export default LanguageSwitcher;
